<template>
  <div class="column justify-center items-center">
    <q-card class="accept-invite-card bg-white">
      <q-card-main>
        <div class="row justify-center q-mt-lg">
          <team-logo class="q-display-3" :team="team" height="120px" width="120px"/>
        </div>

        <div class="text-center">
          <i18n tag="div" class="q-my-lg q-body-1" path="invite_text">
            <h4 place="team" class="no-margin">{{ invite.team }}</h4>
          </i18n>

          <p>
            {{ $t('access_rights') }}:<br/>
            <span class="text-faded">{{ roleName }}</span>
          </p>
        </div>

        <div class="row justify-center">
          <template v-if="authenticated">
            <q-btn @click="accept" type="submit" color="primary">{{ $t('accept') }}</q-btn>
          </template>
          <template v-else>
            <q-btn @click="setUrlAndRedirect('login')" color="primary"> {{ $t('login') }}</q-btn>
            <q-btn @click="handleRegister" color="primary" class="on-right"> {{ $t('register') }}</q-btn>
          </template>
        </div>
      </q-card-main>
    </q-card>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { InviteClient } from 'src/api/Invites'
  import { LocalStorage } from 'quasar'
  import TeamLogo from 'components/Common/TeamLogo.vue'
  import { createErrorFromResponse } from 'src/utils/error'

  export default {
    props: {
      token: {
        type: String,
        required: true
      }
    },

    data () {
      return {
        invite: {}
      }
    },

    beforeRouteEnter (to, from, next) {
      new InviteClient()
        .preview(to.params.token)
        .then(result => {
          next(vm => {
            vm.invite = result.data.data[0]
          })
        })
        .catch(error => {
          next(vm => {
            createErrorFromResponse(error)

            vm.$router.push('/')
          })
        })
    },

    computed: {
      ...mapGetters(['authenticated']),

      roleName () {
        return this.invite.role_id ? this.$t(`role_${this.invite.role_id}`) : ''
      },

      team () {
        // Create a dummy team since the team logo component requires a valid team
        return {
          name: this.invite.team || '',
          settings: {
            logo_url: this.invite.logo
          }
        }
      }
    },

    methods: {
      ...mapActions(['refreshUserData']),

      accept () {
        new InviteClient()
          .accept(this.token)
          .then(this.refreshUserData)
          .then(() => {
            this.$router.push({ name: 'dashboard', params: { teamId: this.invite.team_id } })

            this.$q.notify({ type: 'positive', message: this.$t('invite_accepted') })
          })
          .catch(createErrorFromResponse)
      },

      handleRegister () {
        this.setUrlAndRedirect('register', {
          query: { name: this.invite.name, email: this.invite.email }
        })
      },

      setUrlAndRedirect (name, params = {}) {
        LocalStorage.set('redirect_url', location.pathname)

        this.$router.push({ name, ...params })
      }
    },

    components: {
      TeamLogo
    }
  }
</script>

<style lang="stylus">
  @import '~variables'

  .accept-invite-card
    width: 90vw
    margin: 3vw
    max-width: 500px
</style>
